import TeacherLayout from '@/layouts/TeacherLayout.vue';

const teacherRoutes = [
  {
    path: '/teacher',
    component: TeacherLayout,
    meta: { 
      requiresAuth: true,
      role: 'teacher'
    },
    children: [
      {
        path: '',
        name: 'TeacherHome',
        component: () => import('@/views/teacher/Home.vue'),
        meta: { title: '教师首页' }
      },
      {
        path: 'attendance',
        name: 'TeacherAttendance',
        component: () => import('@/views/teacher/Attendance.vue'),
        meta: { title: '签到管理' }
      },
      {
        path: 'rating',
        name: 'TeacherRating',
        component: () => import('@/views/teacher/Rating.vue'),
        meta: { title: '学生评分' }
      },
      {
        path: 'assignments',
        name: 'TeacherAssignments',
        component: () => import('@/views/teacher/Assignments.vue'),
        meta: { title: '学生作业' }
      },
      {
        path: 'scores',
        name: 'TeacherScores',
        component: () => import('@/views/teacher/Scores.vue'),
        meta: { title: '学生成绩' }
      },
      {
        path: 'communication',
        name: 'TeacherCommunication',
        component: () => import('@/views/teacher/Communication.vue'),
        meta: { title: '家长沟通' }
      },
      {
        path: 'wrong-questions',
        name: 'TeacherWrongQuestions',
        component: () => import('@/views/teacher/WrongQuestions.vue'),
        meta: { title: '错题记录' }
      },
      {
        path: 'documents',
        name: 'TeacherDocuments',
        component: () => import('@/views/teacher/Documents.vue'),
        meta: { title: '文库查看' }
      }
    ]
  },
  {
    path: '/:schoolCode/:campusCode/teacher/wrong-questions/student/:studentId',
    name: 'StudentWrongQuestions',
    component: () => import('@/views/teacher/StudentWrongQuestions.vue'),
    meta: {
      requiresAuth: true,
      role: 'teacher'
    }
  },
  {
    path: '/:schoolCode/teacher/wrong-questions/student/:studentId',
    name: 'StudentWrongQuestionsSchool',
    component: () => import('@/views/teacher/StudentWrongQuestions.vue'),
    meta: {
      requiresAuth: true,
      role: 'teacher'
    }
  },
  {
    path: '/teacher/wrong-questions/student/:studentId',
    name: 'StudentWrongQuestionsOnly',
    component: () => import('@/views/teacher/StudentWrongQuestions.vue'),
    meta: {
      requiresAuth: true,
      role: 'teacher'
    }
  },
  {
    path: '/:schoolCode/:campusCode/teacher/wrong-questions/books/:bookId',
    name: 'WrongQuestionBookDetail',
    component: () => import('@/views/teacher/WrongQuestionBookDetail.vue'),
    meta: {
      requiresAuth: true,
      role: 'teacher'
    }
  },
  {
    path: '/:schoolCode/teacher/wrong-questions/books/:bookId',
    name: 'WrongQuestionBookDetailSchool',
    component: () => import('@/views/teacher/WrongQuestionBookDetail.vue'),
    meta: {
      requiresAuth: true,
      role: 'teacher'
    }
  },
  {
    path: '/teacher/wrong-questions/books/:bookId',
    name: 'WrongQuestionBookDetailOnly',
    component: () => import('@/views/teacher/WrongQuestionBookDetail.vue'),
    meta: {
      requiresAuth: true,
      role: 'teacher'
    }
  }
];

export default teacherRoutes; 